<template>
  <div id="app">
    <router-view />
  </div>
</template>


<script>
export default {
  name: 'App',
  data() {
    return {
      region: []
    }
  },
  watch: {
    '$store.state.user.token'(token, oldToken) {
      console.log(token, oldToken, 'token')
      if (token && token !== oldToken) {
        this.getAllRegion();
      }
    }
  },
  methods: {
    async getAllRegion() {
      let result = await this.$Api.getAllRegion();
      console.log("省市区", result)
      if (result.code == 200) {
        this.region = result.data.list || [];
        localStorage.setItem("region", JSON.stringify(result.data.list || []));
      }
    }
  },
  mounted() {
    console.log(process.env)
    let token  = localStorage.getItem("token");
    if(token){
    this.getAllRegion();
    }
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.el-input__inner {
  height: 35px !important;
  line-height: 35px !important;
}

.OF {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Ma {
  margin: 0 auto;
}

.flex {
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
}

.flexR {
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.flexRr {
  -webkit-flex-direction: row-reverse;
  -moz-flex-direction: row-reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;

  button {
    margin-left: 20px;
  }
}

.flexC {
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.flexJ {
  justify-content: space-between;
}

.flexJp {
  justify-content: space-around;
}

.flexJc {
  justify-content: center;
}

.center1 {
  -moz-box-align: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -moz-box-pack: center;
  -webkit-box-pack: center;
}
.alignC{
     align-items: center;
    justify-content: center;
}
.top {
  -moz-box-align: flex-start;
  -webkit-box-align: flex-start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -moz-box-pack: flex-start;
  -webkit-box-pack: flex-start;
}
.Jb {
  background: -moz-linear-gradient(top, #ffffff 0%, #e6e6e6 100%);
  background: -webkit-gradient(linear,
      left top,
      left bottom,
      color-stop(0%, #ffffff),
      color-stop(100%, #e6e6e6));
  background: -webkit-linear-gradient(top, #ffffff 0%, #e6e6e6 100%);
  background: -o-linear-gradient(top, #ffffff 0%, #e6e6e6 100%);
  background: -ms-linear-gradient(top, #ffffff 0%, #e6e6e6 100%);
}
.C {
  text-align: center;
}
.CL {
  text-align: left;
}
.CR {
  text-align: right;
}
.cp {
  cursor: pointer;
}
.el-table__fixed-right,.el-table__fixed {
  background: #fff !important;
  z-index: 99 !important;
}
</style>
